import {
  AppBar,
  ArrowRightIcon,
  Box,
  GKButton,
  List,
  ListItem,
  Typography,
} from "components";
import { useFormContext, useWatch } from "react-hook-form";
import { useAppSelector } from "store/store";
import { WebsiteDetails } from "../types";

function WebsiteHeader() {
  const form = useFormContext<WebsiteDetails>();

  const { croppedImage } = useAppSelector((state) => state.myWebsite);

  const websiteHeader = useWatch({
    control: form.control,
    name: "websiteSection.myBranding",
  });

  return (
    <Box
      sx={{ position: "sticky", top: 0, zIndex: 99, width: "100%" }}
      maxWidth={{ xs: "100vw", md: "1192px" }}
      margin={"auto"}
    >
      <AppBar
        position="sticky"
        sx={{ py: 1, boxShadow: "none", background: "#fff" }}
      >
        <Box
          sx={{
            p: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <ListItem
            sx={{
              p: 0,
              width: "max-content",
              "&:hover": { cursor: "pointer" },
            }}
          >
            <img
              src={
                (croppedImage as string) ||
                (websiteHeader?.companyLogo as string) ||
                "/Logos/iconFullLogo.png"
              }
              alt=""
              width={"auto"}
              height={"auto"}
              style={{ maxHeight: "52px" }}
            />
          </ListItem>
          <List
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: 0,
            }}
          >
            <GKButton
              variant="text"
              color="dark"
              sx={{
                whiteSpace: "nowrap",
                p: 0.5,
                display: { xs: "none", md: "flex" },
              }}
            >
              <Typography color="#4F4F4F" fontSize={12} fontWeight={600}>
                How it works?
              </Typography>
            </GKButton>
            <GKButton
              variant="text"
              color="dark"
              sx={{
                whiteSpace: "nowrap",
                p: 0.5,
                display: { xs: "none", md: "flex" },
              }}
            >
              <Typography color="#4F4F4F" fontSize={12} fontWeight={600}>
                Products
              </Typography>
            </GKButton>
            <GKButton
              variant="text"
              color="dark"
              sx={{
                whiteSpace: "nowrap",
                p: 0.5,
                display: { xs: "none", md: "flex" },
              }}
            >
              <Typography color="#4F4F4F" fontSize={12} fontWeight={600}>
                About Analyst
              </Typography>
            </GKButton>
            <GKButton variant="contained" endIcon={<ArrowRightIcon />}>
              Sign In
            </GKButton>
          </List>
        </Box>
      </AppBar>
    </Box>
  );
}
export default WebsiteHeader;
